import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './páginas/Dashboard'; 
import Login from './páginas/Loginn'; 
import Registo from './páginas/Registo'; 
import EsqueciPassword from './páginas/EsqueciPassword'; 
import RedefinirPassword from './páginas/RedefinirPassword';
import LandingPage from './páginas/LandingPage';
import Biblioteca from './páginas/Biblioteca';
import DashboardSoA from'./páginas/DashboardSoA';
import Auditoria from './páginas/Auditoria';
import Auditorias from './páginas/Auditorias';
import Riscos from './páginas/Riscos';
import Perfil from './páginas/Perfil';
import Definicoes from './páginas/Definicoes';    
import CursosConcluidos from './páginas/CursosConcluidos';
import CursoPlayer from './páginas/CursoPlayer';

// IMPORTA O TEU NOVO SEGURANÇA!
import RotaPrivada from './RotaPrivada';

function App() {  
  return (
    <Router>
      <Routes>
        {/* ========================================== */}
        {/* 🟢 ZONA PÚBLICA (Qualquer um pode aceder)  */}
        {/* ========================================== */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registo" element={<Registo />} />
        <Route path="/recuperar-password" element={<EsqueciPassword />} />
        <Route path="/redefinir-password" element={<RedefinirPassword />} />

        {/* ========================================== */}
        {/* 🔴 ZONA PRIVADA (Só entra com Token!)      */}
        {/* ========================================== */}
        <Route element={<RotaPrivada />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/biblioteca" element={<Biblioteca />} />
          <Route path="/auditorias" element={<Auditorias />} />
          <Route path="/auditorias/nova" element={<Auditoria />} />
          <Route path="/auditoria/:id" element={<Auditoria />} />
          <Route path="/riscos" element={<Riscos />} />
          <Route path="/perfil" element={<Perfil />} />
          <Route path="/meu-soa" element={<DashboardSoA />} />  
          <Route path="/definicoes" element={<Definicoes />} />
          <Route path="/cursos-concluidos" element={<CursosConcluidos />} />
          <Route path="/curso/:id" element={<CursoPlayer />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;